<div class="container pb-10">
  <app-sections-guide [links]="links"></app-sections-guide>

  <router-outlet></router-outlet>
</div>
